export { default } from './UCASPoints';
export type { Props } from './UCASPoints';
